import React from "react";
import loginStyles from "../../common/styles/Login";
import { Grid, styled , Link } from "@gti-controls-v2/web-core";

const ResponsiveDiv = styled("div")(({ theme }) => ({
    padding: 10,
    [theme.breakpoints.up('md')]: {
        width: '100%',
        fontSize: '16px',
        lineHeight: '24px',
        marginTop: 'auto',
        color: '#ffffff',
        padding: 10,
    },
    [theme.breakpoints.down('md')]: {
        color: "#0b5c96",
        fontSize: '12px',
        position: 'absolute',
        bottom: 0,
        width: 'inherit',
        right: 0,
    }
  }));

const Footer = () => {
    const styles = loginStyles;

    return (
        <ResponsiveDiv>
            <Grid container sx={styles.footerGrid}>
                <Grid item sx={styles.footerTitle}>
                    Servicios de Tecnología Contable S.C.
                </Grid>
                <Grid item sx={styles.footerSubtitle}>
                    &nbsp;| Derechos reservados &copy; {new Date().getFullYear()}
                </Grid>
                <Grid item sx={styles.footerLinks}>
                    <Grid container>
                        <Grid item>
                            <Link style={{ textDecoration: 'underline' }} color="inherit" onClick={() => { }}>Términos de uso</Link>
                        </Grid>
                        <Grid item>
                            <div>&nbsp;&nbsp;|&nbsp;&nbsp;</div>
                        </Grid>
                        <Grid item>
                            <Link style={{ textDecoration: 'underline' }} color="inherit" onClick={() => { }}>Política de privacidad</Link>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ResponsiveDiv>
    );
};

export default Footer;